// Déclaration des routes des écrans personnalisés et des bannettes
export const customizedScreenRoutes = [];